import { useState } from "react";
import { addActivityReaction, addBulkActivityReactions } from "../../services/professorActivityService";

export default function useActivityReactions(user, professorProfile) {
  const [processingReaction, setProcessingReaction] = useState(false);

  const addReaction = async (activity, reactionType, activities, setActivities) => {
    try {
      setProcessingReaction(true);
      const res = await addActivityReaction(activity.id, {
        type: reactionType,
        signature: professorProfile?.signature || null,
        from_source: "Professor",
      });

      // Optimistically update local activities state
      const profName = user?.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : (user?.username || 'Professor');
      const updatedStatus = reactionType === '✅' ? 'APPROVED' : (reactionType === '❌' ? 'REJECTED' : activity.status);

      if (setActivities && Array.isArray(activities)) {
        setActivities((prev) =>
          prev.map((act) => {
            if (act.id === activity.id) {
              const currentReactions = act.reactions || [];
              const filtered = currentReactions.filter((r) => r.professorEmail !== user?.email);
              filtered.push({
                type: reactionType,
                from: profName,
                professorEmail: user?.email,
                professorId: user?.id,
                timestamp: new Date().toISOString(),
                from_source: "Professor",
              });
              return { ...act, status: updatedStatus, reactions: filtered };
            }
            return act;
          })
        );
      }

      return { success: true, data: res };
    } catch (err) {
      console.error("Error adding reaction:", err);
      const msg = err.response?.data?.error || err.message || "Failed to save reaction";
      return { success: false, error: msg };
    } finally {
      setProcessingReaction(false);
    }
  };

  const addBulkReactions = async (selectedActivityIds, reactionType, activities, setActivities) => {
    try {
      setProcessingReaction(true);
      const res = await addBulkActivityReactions(selectedActivityIds, {
        type: reactionType,
        signature: professorProfile?.signature || null,
        from_source: "Professor",
      });
      return { success: true, data: res };
    } catch (err) {
      console.error("Error bulk reactions:", err);
      const msg = err.response?.data?.error || err.message || "Failed bulk reaction";
      return { success: false, error: msg };
    } finally {
      setProcessingReaction(false);
    }
  };

  return {
    processingReaction,
    addReaction,
    addBulkReactions,
  };
}
